const styles = () => ({
    item: {
        paddingRight: '12px',
    },
});

export default styles;
